import { render, staticRenderFns } from "./paperdevicegroup.vue?vue&type=template&id=32626607&scoped=true&"
import script from "./paperdevicegroup.vue?vue&type=script&lang=js&"
export * from "./paperdevicegroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32626607",
  null
  
)

export default component.exports